import React, {FC, useCallback} from 'react';
import {useNavigate} from 'react-router-native';

import {Layout} from '@components/layouts/layout/Layout';
import {PageEventView} from '@domain/model/Event/domain/model/UiEvents';
import {useHardwareBackPress} from '../../components/hooks/useHardwareBackPress';
import {usePageLoad} from '@tracking/usePageLoad';

import {ReferralsCompleted} from './ReferralsCompleted';
import {ReferralsPending} from './ReferralsPending';
import {OverlaySpinner} from '@components/atoms';
import {ReferralsProvider, useReferrals} from '@views/Referrals/_contexts/ReferralsContext';

const ReferralsView: FC = () => {
  const {hasReferreds, loading} = useReferrals();

  if (loading) return <OverlaySpinner />;
  if (hasReferreds) return <ReferralsCompleted />;
  return <ReferralsPending />;
};

const Referrals: FC = () => {
  usePageLoad(PageEventView.REFERRAL);

  const navigate = useNavigate();
  const onBack = useCallback(() => navigate(-1), [navigate]);
  useHardwareBackPress(onBack);

  return (
    <Layout>
      <ReferralsProvider>
        <ReferralsView />
      </ReferralsProvider>
    </Layout>
  );
};

export {Referrals};
